import { render, staticRenderFns } from "./CompaniesAwaitingApproval.vue?vue&type=template&id=0152096e"
import script from "./CompaniesAwaitingApproval.vue?vue&type=script&lang=js"
export * from "./CompaniesAwaitingApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports